import axios from 'axios';

const KIT_BACKEND_URL = import.meta.env.VITE_ITRANSFORM_KIT_BACKEND_URL;
const KIT_API_KEY = import.meta.env.VITE_ITRANSFORM_KIT_API_KEY;

const kitAxiosInstance = axios.create({
  baseURL: `${KIT_BACKEND_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': KIT_API_KEY,
  },
});

kitAxiosInstance.interceptors.request.use((config) => {
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
});

export default kitAxiosInstance;
